import React, { ReactNode } from 'react';
import styles from './Header.module.scss';

export interface HeaderProps {
  left?: ReactNode,
  children?: ReactNode,
  right?: ReactNode
}
function Header(props: HeaderProps) {
  const { left, children, right } = props;
  return (
    <div className={styles.container}>
      { left && <div className={styles.left}>{ left }</div>}
      <div className={styles.content}>{children}</div>
      { right && <div className={styles.right}>{ right }</div>}
    </div>
  )
}

export default Header;